import styled from 'styled-components';

import { CloseButton } from 'atoms/buttons/CloseButton';
import { SBHorizontal } from 'atoms/layout/flex';
import { BackButton } from 'components/dialog/BackButton';

const Root = styled(SBHorizontal)`
  width: 100%;
`;

type Props = {
  onClose?: () => void;
  onBack?: () => void;
};

export const Header = ({ onClose, onBack }: Props) => {
  return (
    <Root>
      <div>{!!onBack && <BackButton onBack={onBack} />}</div>
      <div>{!!onClose && <CloseButton size="medium" onClose={onClose} />}</div>
    </Root>
  );
};
